import { makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import clsx from 'clsx';
import React from 'react';
import { ProductDetailProduct } from '../../../api/products/productDetail';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export interface ProductDetailNameProps extends StandardDivProps<ProductDetailNameClassKey> {
  product: ProductDetailProduct;
}

export type ProductDetailNameClassKey = 'root' | 'name';

const useStyles = makeStyles((theme) => ({
  root: {},
  name: {
    ...theme.typography.h1,
    fontSize: '2.2rem',
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.primary.main,
    margin: 0,
    padding: theme.spacing(1, 0),
    [theme.breakpoints.down('md')]: {
      fontSize: '1.9rem',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.65rem',
    },
  },
}));

const ProductDetailName: React.FC<ProductDetailNameProps> = React.forwardRef(({ className, product, ...rest }, ref) => {
  const classes = useStyles();
  const t = useTranslateWithFallback();

  return (
    <div ref={ref} className={clsx(classes.root, className)} {...rest}>
      <h1 className={classes.name}>{t(product.name, { acceptString: true })}</h1>
    </div>
  );
});

ProductDetailName.displayName = 'ProductDetailName';

export default ProductDetailName;
